import { Action } from 'redux'
import { isType } from 'ts-action'
import { ILocationVerificationEvidenceReducer } from 'models/LocationVerificationEvidence'
import { GetLocationVerificationEvidence, LocationVerificationEvidenceFetching } from './actions'

const initialState: ILocationVerificationEvidenceReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const locationVerificationEvidenceReducer = (
  state = initialState,
  action: Action
): ILocationVerificationEvidenceReducer => {
  if (isType(action, GetLocationVerificationEvidence)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, LocationVerificationEvidenceFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
